module.exports = __webpack_public_path__ + "img/Mage-draenei-m-70.5470063b.gif";